// @greenlight-spec: 19-design-system.md

import * as React from 'react';

/** Decorative agent mark for a card header; bundled assets, dark variant when the mark is near-black (public/brands/README.md). */
export function AgentMark({ src, darkSrc }: { src: string; darkSrc?: string }): React.ReactElement {
  return (
    <span className="inline-flex h-4 w-4 shrink-0 items-center justify-center" aria-hidden="true">
      <img
        src={src}
        alt=""
        width={16}
        height={16}
        className={darkSrc ? 'dark:hidden' : undefined}
      />
      {darkSrc && <img src={darkSrc} alt="" width={16} height={16} className="hidden dark:block" />}
    </span>
  );
}

export const CODEX_MARK = { src: '/brands/openai.svg', darkSrc: '/brands/openai-dark.svg' };
export const CLAUDE_MARK = { src: '/brands/claude.svg' };
export const CURSOR_MARK = { src: '/brands/cursor.svg', darkSrc: '/brands/cursor-dark.svg' };
export const COPILOT_MARK = { src: '/brands/github.svg', darkSrc: '/brands/github-dark.svg' };
